// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1f7bc485","977":"1890dc0c"}[chunkId] + ".chunk.js";
};